import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';

import { buttonsReset } from 'src/store/modules/buttons';
import { editTextReset } from 'src/store/modules/editText';
import { imageReset } from 'src/store/modules/imageUpload';
import { pagesReset } from 'src/store/modules/pages';

import setInitValue from 'src/utils/setInitValue';
import { changeEnter } from 'src/utils/changeEnter';
import { initTrackingValues } from '../TemplateTracking/RadiusFullCountdownTracking';
import { editUserCompany } from 'src/store/modules/client';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';

let today = new Date();

const initViewValues = {
  bgImage: {
    background: 'https://image.inappmessage.com/sample/defaultIMAGE.webp'
  },
  bgImageBlur: { background: 0 },
  radius: { button: 0 },
  deeplink: { background: 'https://www.inappmessage.com/' },

  text: {
    title: 'TIK-TOK',
    sub_title: 'Only 2DAYS Event!',
    countdown_title: 'Time left',
    countdown: {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      date: today.getDate() + 1,
      hour: 0,
      min: 0,
      sec: 0
    }
  },
  fontSize: { title: 2.5, sub_title: 1, countdown_title: 1, countdown: 2.5 },
  fontWeight: {
    title: 700,
    sub_title: 500,
    countdown_title: 400,
    countdown: 700
  },
  color: {
    title: '#ffffff',
    sub_title: '#ffffff',
    countdown_title: '#ffffff',
    countdown: '#ffffff'
  },
  fontFamily: {
    title: 'Montserrat',
    sub_title: 'Montserrat',
    countdown_title: 'Montserrat',
    countdown: 'Montserrat'
  },
  textAlign: {
    title: 'center',
    sub_title: 'center',
    countdown_title: 'center'
  },

  btnText: { button: 'SHOW UP', sub_button: '닫기' },
  btnFontSize: { button: 1, sub_button: 0.75 },
  btnFontWeight: { button: 500, sub_button: 400 },
  btnColor: { button: '#ffffff', sub_button: '#ffffff' },
  btnBgColorR: { button: 0, sub_button: 0 },
  btnBgColorG: { button: 0, sub_button: 0 },
  btnBgColorB: { button: 0, sub_button: 0 },
  btnBgColorA: { button: 1, sub_button: 0 },
  btnFontFamily: { button: 'Montserrat', sub_button: 'Montserrat' }
};

const RadiusFullCountdown: FC = () => {
  const dispatch = useDispatch();
  const [currentUser, setCurrentUser] = useState('');

  let templateWidth = useSelector((state: any) => state.template.templateWidth);
  let templateHeight = useSelector(
    (state: any) => state.template.templateHeight
  );
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let bgImageBlur = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );
  let deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);
  let radius = useSelector((state: RootState) => state.imageUpload.radius);

  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  let textAlign = useSelector((state: RootState) => state.editText.textAlign);

  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  let btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  let btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  let btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        setCurrentUser(current.attributes['custom:Company']);
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);

  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const countdownTitleFontURL = getFontURL(fontFamily?.countdown_title);
  const countdownFontURL = getFontURL(fontFamily?.countdown);
  const btnFontURL = getFontURL(btnFontFamily?.button);
  const subBtnFontURL = getFontURL(btnFontFamily?.sub_button);
  // const titleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.title}`;
  // const subTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.sub_title}`;
  // const countdownTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.countdown_title}`;
  // const countdownFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.countdown}`;
  // const btnFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.button}`;
  // const subBtnFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.sub_button}`;

  const plusImageUrl = 'https://i.ibb.co/qMpSJ4w/Group-20.png';
  // ${
  //   bgImage?.background || bgImage?.background !== ''
  //     ? `background-image: url(${bgImage?.background});`
  //     : `background: rgba(0, 0, 0, 0.8);`
  // };

  // ${
  //   bgImage?.background || bgImage?.background !== ''
  //     ? `background-image: url(${bgImage?.background});`
  //     : `background: rgba(0, 0, 0, 0.8);`
  // };
  // filter: blur(${bgImageBlur?.background}px);
  const style = `
  @font-face {
    font-family: 'title';
    src: url('${titleFontURL}');
  }
  @font-face {
    font-family: 'subTitle';
    src: url('${subTitleFontURL}');
  }
  @font-face {
    font-family: 'countdownTitle';
    src: url('${countdownTitleFontURL}');
  }
  @font-face {
    font-family: 'countdown';
    src: url('${countdownFontURL}');
  }
  @font-face {
    font-family: 'button';
    src: url('${btnFontURL}');
  }
  @font-face {
    font-family: 'subButton';
    src: url('${subBtnFontURL}');
  }
  .root_view {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    
    .backgroundImage {
      background: rgba(0, 0, 0, 0.8);
      width: 100%;
      height: 100%;

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }

    .close_btn {
      height: 1.5rem;
      position: absolute;
      top: 6%;
      right: 10%;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      display: flex;
      align-items: center;

      font-size: ${btnFontSize?.sub_button}rem;
      font-weight: ${btnFontWeight?.sub_button};
      color: ${btnColor?.sub_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.sub_button
        )
          ? btnFontFamily?.sub_button
          : 'subButton'
      };
      letter-spacing: 0.0225rem;
    }

    .center {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      display: flex;
      flex-direction: column;
      gap: 3rem;
    }
    .top {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .top_center {
      width: 80%;
    }
    .top .sub_title {
      height: 1.5rem;
      text-align: ${textAlign?.sub_title};
      font-size: ${fontSize?.sub_title}rem;
      font-weight: ${fontWeight?.sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.sub_title
        )
          ? fontFamily?.sub_title
          : 'subTitle'
      };
      color: ${color?.sub_title};

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .top .title {
      height: 3rem;
      text-align: ${textAlign?.title};
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.title
        )
          ? fontFamily?.title
          : 'title'
      };
      color: ${color?.title};

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .circle_wrapper {
      width: 100%;
      height: 25rem;
      position: relative;
      text-align: center;
    }
    .circleImage  {
      width: 25rem;
      height: 25rem;

      ${
        bgImage?.background || bgImage?.background !== ''
          ? `background-image: url(${bgImage?.background})`
          : `background-color: #D9D9D9`
      };

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      border-radius: 25rem;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
    .modal_wrapper {
      color: #000;
      font-size: 0.78513rem;
      font-weight: 400;
      font-family: Roboto;
    }
    .plus_btn button {
      width: 1.1rem;
      height: 1.1rem;
      
      background-image: url(${plusImageUrl});
      background-repeat: no-repeat;
      background-size: 1.1rem;
      background-position: center;

      font-size: 0;
      border: none;
      border-radius: 50%;
      background-color: transparent;
    }

    .countdown_grid {
      display: grid;
      grid-template-columns: 3.5rem 0.5rem 3.5rem 0.5rem 3.5rem;
      justify-content: space-between;
      gap: 0.5rem;
    }
    .countdown_grid li {
      text-align: center;
    }
  
    .bottom {
      width: 100%;
    }
    .bottom ul {
      height: 2.5rem;
      padding: 0 10%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      font-size: ${fontSize?.countdown}rem;
      font-weight: ${fontWeight?.countdown};
      color: ${color?.countdown};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.countdown
        )
          ? fontFamily?.countdown
          : 'countdown'
      };
    }
    .bottom li {
      list-style: none;
    }
    .bottom .countdown_title {
      font-size: ${fontSize?.countdown_title}rem;
      font-weight: ${fontWeight?.countdown_title};
      color: ${color?.countdown_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.countdown_title
        )
          ? fontFamily?.countdown_title
          : 'countdownTitle'
      };
    }

    .bottom_btn {
      width: 100%;
      position: absolute;
      bottom: 0;
    }
    .bottom_btn button {
      width: 100%;
      height: 4.5rem;
      border: 0;
      padding: 1rem 2rem 1.5rem 2rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.button}rem;
      font-weight: ${btnFontWeight?.button};
      color: ${btnColor?.button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.button
        )
          ? btnFontFamily?.button
          : 'button'
      };
      border-radius: ${radius?.button}px ${radius?.button}px 0 0;
      background-color: rgba(${btnBgColorR?.button}, ${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});
    }

    ${
      templateHeight < 699
        ? `
        .center {
          gap: 0.5rem;
        }

        .circle_wrapper {
          height: 20rem;
        }
        .circleImage  {
          width: 20rem;
          height: 20rem;
          border-radius: 20rem;
        }
        `
        : ``
    }

    ${
      templateWidth > 767
        ? `
        .close_btn {
          font-size: 1.25rem;
          top: 10%;
          right: 25%;
        }

        .top .sub_title {
          height: 2rem;
          font-size: ${fontSize?.sub_title + 0.5}rem;
        }
        .top .title {
          height: 4rem;
          font-size: ${fontSize?.title + 1}rem;
        }

        .center {
          gap: 2rem;
        }
        .circle_wrapper {
          height: 35rem;
        }
        .circleImage  {
          width: 35rem;
          height: 35rem;
          border-radius: 35rem;
        }

        .bottom ul {
          padding: 0 25%;
          font-size: ${fontSize?.countdown + 2}rem;
        }
        .bottom .countdown_title {
          font-size: ${fontSize?.countdown_title + 0.25}rem;
        }
        `
        : ``
    }
  }
  `;

  const [finish, setFinish] = useState(false);

  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    setFinish(false);
    const future = Date.parse(
      `${text?.countdown?.year}/${text?.countdown?.month}/${text?.countdown?.date} ${text?.countdown?.hour}:${text?.countdown?.min}:${text?.countdown?.sec}`
    );

    const interval = setInterval(() => {
      const now: any = new Date();
      const diff = future - now;
      if (diff <= 0 || isNaN(diff)) {
        setFinish(true);
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const mins = Math.floor(diff / (1000 * 60));
      const secs = Math.floor(diff / 1000);

      const d = days;
      const h = hours - days * 24;
      const m = mins - hours * 60;
      const s = secs - mins * 60;

      const date = h + d * 24;
      setHours(date);
      setMinutes(m);
      setSeconds(s);
    }, 1000);

    return () => clearInterval(interval);
  }, [text?.countdown]);

  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());

      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());
      dispatch(trackingReset());
    };
  }, []);

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_view">
        <div className="backgroundImage"></div>
        <div className="close_btn">{btnText?.sub_button}</div>

        <div className="center">
          <div className="top">
            <div className="top_center">
              <div className="sub_title">{changeEnter(text?.sub_title)}</div>
              <div className="title">{changeEnter(text?.title)}</div>
            </div>
          </div>

          {/* <div className="circleImageRelative" /> */}
          <div className="circle_wrapper">
            <div className="circleImage">
              {(!bgImage?.background || bgImage?.background === '') && (
                <div className="modal_wrapper">
                  텍스트가 포함된
                  <br />
                  이미지 또는 배경 이미지를
                  <br />
                  추가하세요
                  <div className="plus_btn">
                    <button>plus</button>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="bottom">
            <ul className="countdown timer" id="timer">
              <li className="countdown_title">
                Time left
                {/* {text?.countdown_title} */}
              </li>
              {finish ? (
                <div className="countdown_title">종료되었습니다.</div>
              ) : (
                <div className="countdown_grid">
                  <li>{hours}</li>
                  <li>:</li>
                  <li>{minutes}</li>
                  <li>:</li>
                  <li>{seconds}</li>
                </div>
              )}
            </ul>
          </div>
        </div>

        <div className="bottom_btn">
          <button>{btnText?.button}</button>
        </div>
      </div>
    </>
  );
};
export default RadiusFullCountdown;
